import { FC, FormEvent } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle } from "@mui/material"
import { useThemeContext } from '../../theme/ThemeContext';
import Paper, { PaperProps } from '@mui/material/Paper';
import Draggable from 'react-draggable';

function PaperComponent(props: PaperProps) {
  return (
    <Draggable
      handle="#draggable-dialog"    
    >
      <Paper {...props} />
    </Draggable>
  );
}

export interface ModalDialogProps {
    isOpen: boolean;
    onConfirm?: (event?:FormEvent) => void;
    onCancel?: () => void;
    title: string;
    dialogProps?: DialogProps;
    children?: JSX.Element;
    isDraggable?: boolean;
    submit?: boolean;
    textOk?: string;
    textCancel?: string
  }

export const GenericModalDialog: FC<ModalDialogProps> = ({
    isOpen,
    onConfirm,
    onCancel,
    title,
    dialogProps,
    isDraggable,
    submit,
    textOk,
    textCancel,
    children
  }) => {
 
    const handleClose = (
      event: {},
      reason: "backdropClick" | "escapeKeyDown"
    ) => {
      if (reason !== "backdropClick") {
        onCancel && onCancel();
      }    
    };
    
    const { theme } = useThemeContext()

    return (
        <>
        <Dialog 
          open={isOpen} 
          {...dialogProps} 
          disableRestoreFocus
          onClose={handleClose}
          PaperComponent={isDraggable ? PaperComponent : undefined}
          aria-labelledby="draggable-dialog" 
        >          
        <form onSubmit={submit ? onConfirm : undefined}>
        <DialogTitle id="draggable-dialog" sx={{ cursor: `${isDraggable ? 'move':'auto'}`, fontWeight: 'bold', height: '50px', display: 'flex', alignItems: 'center'}}>{title}</DialogTitle>
        <DialogContent sx={{backgroundColor: theme.palette.background.default}}>
          {children}
        </DialogContent>
        <DialogActions sx={{backgroundColor: theme.palette.background.default}}>
          {onCancel && <Button color="error" variant="contained" onClick={onCancel}>{textCancel ? textCancel : 'X'}</Button>}
          {onConfirm && <Button color="success" type={submit ? 'submit' : 'button'} variant="contained" data-testid="generic-ok" onClick={submit ? undefined : onConfirm}>{textOk ? textOk : '✔'}</Button>}
        </DialogActions>
        </form>
      </Dialog>
      </>
    );
    
};